import * as React from "react";
import { useMergeRefs } from "@floating-ui/react";
import { ModalContext } from "../modal-provider/modal-provider.mjs";
const ModalTrigger = (props) => {
  const { children, onClick } = props;
  const { id = "", triggerRef, open, state, isOpen } = React.useContext(ModalContext);
  const ref = useMergeRefs([triggerRef, state == null ? void 0 : state.refs.setReference]);
  const openModal = (child, event) => {
    event.preventDefault();
    if (child.props.onClick) {
      child.props.onClick(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }
    return React.cloneElement(child, {
      ref,
      ...state == null ? void 0 : state.getReferenceProps({
        onClick: (event) => openModal(child, event),
        "aria-controls": id && isOpen ? id : void 0
      }),
      url: "#".concat(id),
      role: "button",
      onKeyDown: (event) => {
        if (event.key === " ") {
          openModal(child, event);
          open();
        }
      }
    });
  }));
};
export {
  ModalTrigger
};
